import { render, staticRenderFns } from "./notification_preferences.vue?vue&type=template&id=a23f510a&"
import script from "./notification_preferences.vue?vue&type=script&lang=js&"
export * from "./notification_preferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports